export default __webpack_public_path__ + "static/media/premium-clock-icon-versa.141eb42378677405f456f70aa49d23b6.svg";